import { getDarkIconColorPair, getTextColorPair } from 'utils/milestoneStatus';

import { FontSizeMap, IconSizeMap } from './FunctionIcon.constants';

export const getIconWrapperStyles = ({ iconColor, iconSize }) => {
  const iconSizeValue = IconSizeMap[iconSize];
  const fontSize = FontSizeMap[iconSize];
  const color = getTextColorPair(iconColor);
  const darkPair = getDarkIconColorPair(iconColor);

  return {
    alignItems: 'center',
    justifyContent: 'center',
    width: `${iconSizeValue}px`,
    height: `${iconSizeValue}px`,
    // Light mode fills the circle with the pale tint passed as iconColor; on dark that leaks
    // near-white, so swap to a low-alpha accent tint + bright glyph from the same family.
    backgroundColor: ({ palette }) => (palette.mode === 'dark' ? darkPair.background : iconColor),
    borderRadius: '100%',
    userSelect: 'none',
    flexShrink: 0,

    '& > *': {
      color: ({ palette }) => (palette.mode === 'dark' ? darkPair.color : color),
      fontSize,
      fontVariationSettings: `'FILL' 0, 'wght' 100, 'GRAD' 0, 'opsz' ${iconSizeValue}`,
    },
  };
};

export const skeletonStyles = {
  flexShrink: 0,
};
